import React, { Component } from "react";
import PropTypes from "prop-types";
import DomHandler from "../../utils/DomHandler";
import ObjectUtils from "../../utils/ObjectUtils";
import classNames from "classnames";
import { DropdownPanel } from "./DropdownPanel";
import { DropdownItem } from "./DropdownItem";
import "./Dropdown.scss";

/*
  custom by tuan 04/06/2018
  document: https://www.primefaces.org/primereact/#/dropdown
*/

export class Dropdown extends Component {
  static defaultProps = {
    id: null,
    value: null,
    options: [],
    optionLabel: null,
    itemTemplate: null,
    labelTemplate: null,
    style: null,
    className: null,
    autoWidth: true,
    scrollHeight: "250px",
    filter: false,
    filterPlaceholder: null,
    editable: false,
    showClear: false,
    placeholder: null,
    required: false,
    disabled: false,
    appendTo: null,
    tabIndex: null,
    autoFocus: false,
    panelClassName: null,
    panelStyle: null,
    dataKey: null,
    inputId: null,
    onChange: null,
    onMouseDown: null,
    onContextMenu: null,
    errorMessage: null,
    onHoverValue: null,
    onHoverLabel: null,
    onHoverItem: null,
    isKeepShow: null,
  };

  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.array,
    optionLabel: PropTypes.string,
    itemTemplate: PropTypes.func,
    labelTemplate: PropTypes.func,
    style: PropTypes.object,
    className: PropTypes.string,
    autoWidth: PropTypes.bool,
    scrollHeight: PropTypes.string,
    filter: PropTypes.bool,
    filterPlaceholder: PropTypes.string,
    editable: PropTypes.bool,
    showClear: PropTypes.bool,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    appendTo: PropTypes.any,
    tabIndex: PropTypes.number,
    autoFocus: PropTypes.bool,
    lazy: PropTypes.bool,
    panelClassName: PropTypes.string,
    panelstyle: PropTypes.object,
    dataKey: PropTypes.string,
    inputId: PropTypes.string,
    onChange: PropTypes.func,
    onMouseDown: PropTypes.func,
    onContextMenu: PropTypes.func,
    loading: PropTypes.bool,
    panelStyle: PropTypes.any,
    onRemote: PropTypes.func,
    errorMessage: PropTypes.string,
    onHoverValue: PropTypes.any,
    onHoverLabel: PropTypes.string,
    onHoverItem: PropTypes.func,
    isKeepShow: PropTypes.bool,
    groupLabels: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      errorMessage: "",
      error: false,
    };

    this.onClick = this.onClick.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    this.onInputKeyDown = this.onInputKeyDown.bind(this);
    this.onEditableInputClick = this.onEditableInputClick.bind(this);
    this.onEditableInputChange = this.onEditableInputChange.bind(this);
    this.onEditableInputFocus = this.onEditableInputFocus.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.onFilterInputChange = this.onFilterInputChange.bind(this);
    this.onFilterInputKeyDown = this.onFilterInputKeyDown.bind(this);
    this.panelClick = this.panelClick.bind(this);
    this.clear = this.clear.bind(this);
  }

  componentDidMount() {
    if (this.props.autoWidth) {
      if (
        !this.props.style ||
        (!this.props.style["width"] && !this.props.style["min-width"])
      ) {
        this.container.style.width = this.nativeSelect.offsetWidth + 30 + "px";
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isKeepShow === false) {
      this.hide();
    }
  }

  componentDidUpdate() {
    if (this.props.filter) {
      this.alignPanel();
    }

    if (this.panel.element.offsetParent) {
      let highlightItem = DomHandler.findSingle(
        this.panel.element,
        "li.ui-state-highlight"
      );
      if (highlightItem) {
        DomHandler.scrollInView(this.panel.itemsWrapper, highlightItem);
      }
    }
  }

  componentWillUnmount() {
    this.unbindDocumentClickListener();
  }

  // Clear filter
  clearFilter() {
    this.setState({ filter: "" });
    if (this.filterInput) {
      this.filterInput.value = "";
    }
  }

  onClick() {
    if (this.props.disabled) {
      return;
    }

    if (this.documentClickListener) {
      this.selfClick = true;
    }
    // const iNode = '<i className="ui-dropdown-clear-icon fa fa-close"></i>';
    // console.log(event.currentTarget.children[3].classList);
    // let clearClick = event.currentTarget.children[3].classList.contains('ui-dropdown-clear-icon');

    if (!this.overlayClick && !this.editableInputClick) {
      this.focusInput.focus();

      if (this.panel.element.offsetParent) {
        this.hide();
      } else {
        this.show();

        const value = "";

        if (this.props.onRemote) {
          this.props.onRemote(value);
        }

        if (this.props.filter) {
          setTimeout(() => {
            this.filterInput.focus();
          }, 200);
        }
      }
    }

    if (this.editableInputClick) {
      this.expeditableInputClick = false;
    }
  }

  panelClick() {
    this.overlayClick = true;
  }

  onInputFocus() {
    DomHandler.addClass(this.container, "ui-state-focus");
  }

  onInputBlur() {
    DomHandler.removeClass(this.container, "ui-state-focus");
  }

  onUpKey(event) {
    if (!this.panel.element.offsetParent && event.altKey) {
      this.show();
    } else {
      let selectedItemIndex = this.findOptionIndex(this.props.value);

      if (selectedItemIndex !== -1) {
        let nextItemIndex = selectedItemIndex + 1;
        if (nextItemIndex !== this.props.options.length) {
          this.selectItem({
            originalEvent: event,
            option: this.props.options[nextItemIndex],
          });
        }
      }

      if (selectedItemIndex === -1) {
        this.selectItem({
          originalEvent: event,
          option: this.props.options[0],
        });
      }
    }

    event.preventDefault();
  }

  onDownKey(event) {
    let selectedItemIndex = this.findOptionIndex(this.props.value);

    if (selectedItemIndex > 0) {
      let prevItemIndex = selectedItemIndex - 1;
      this.selectItem({
        originalEvent: event,
        option: this.props.options[prevItemIndex],
      });
    }

    event.preventDefault();
  }

  onInputKeyDown(event) {
    switch (event.which) {
      //down
      case 40:
        this.onUpKey(event);
        break;

      //up
      case 38:
        this.onDownKey(event);
        break;

      //space
      case 32:
        if (!this.panel.element.offsetParent) {
          this.show();
          event.preventDefault();
        }
        break;

      //enter
      case 13:
        this.hide();
        this.unbindDocumentClickListener();
        event.preventDefault();
        break;

      //escape and tab
      case 27:
      case 9:
        this.hide();
        this.unbindDocumentClickListener();
        break;

      default:
        break;
    }
  }

  onEditableInputClick() {
    this.editableInputClick = true;
    this.bindDocumentClickListener();
  }

  onEditableInputChange(event) {
    this.props.onChange({
      originalEvent: event.originalEvent,
      value: event.target.value,
    });
  }

  onEditableInputFocus() {
    DomHandler.addClass(this.container, "ui-state-focus");
    this.hide();
  }

  onOptionClick(event) {
    if (event.option[this.props.onHoverLabel] !== this.props.onHoverValue) {
      this.selectItem(event);
      this.focusInput.focus();
      this.hide();
      event.originalEvent.stopPropagation();
    } else {
      this.props.onHoverItem();
    }
  }

  onFilterInputChange(event) {
    this.setState({ filter: event.target.value });
  }

  onFilterInputKeyDown(event) {
    switch (event.which) {
      //down
      case 40:
        this.onUpKey(event);
        break;

      //up
      case 38:
        this.onDownKey(event);
        break;

      //enter
      case 13:
        event.preventDefault();
        break;

      default:
        break;
    }
  }

  clear(event) {
    this.props.onChange({
      originalEvent: event,
      value: null,
    });
    this.updateEditableLabel();
  }

  selectItem(event) {
    let selectedOption = this.findOption(this.props.value);
    let value = null;
    value = this.props.optionLabel ? event.option : event.option.value;

    if (value !== null) {
      this.setState({
        error: false,
      });
    }

    if (selectedOption !== event.option) {
      this.updateEditableLabel(event.option);
      this.props.onChange({
        originalEvent: event.originalEvent,
        value: this.props.optionLabel ? event.option : event.option.value,
      });
    }
  }

  findOptionIndex(value) {
    let index = -1;
    if (this.props.options) {
      for (let i = 0; i < this.props.options.length; i++) {
        let optionValue = this.props.optionLabel
          ? this.props.options[i]
          : this.props.options[i].value;
        /* if ((value === null && optionValue === null) || ObjectUtils.equals(value, optionValue, this.props.dataKey)) {
            index = i;
            break;
          }*/
        if (value !== null && optionValue !== null) {
          if (value.value === optionValue.value) {
            index = i;
            break;
          }
        }
      }
    }

    return index;
  }

  findOption(value) {
    let index = this.findOptionIndex(value);
    return index !== -1 ? this.props.options[index] : null;
  }

  show() {
    this.panel.element.style.zIndex = String(DomHandler.generateZIndex());
    this.panel.element.style.display = "block";
    this.alignPanel();
    DomHandler.fadeIn(this.panel.element, 250);
    this.bindDocumentClickListener();
  }

  hide() {
    this.panel.element.style.display = "none";
    this.unbindDocumentClickListener();
    this.clearClickState();
    this.clearFilter();
  }

  alignPanel() {
    if (this.props.appendTo) {
      DomHandler.absolutePosition(this.panel.element, this.container);
      this.panel.element.style.minWidth =
        DomHandler.getWidth(this.container) + "px";
    } else {
      DomHandler.relativePosition(this.panel.element, this.container);
    }
  }

  bindDocumentClickListener() {
    if (!this.documentClickListener) {
      this.documentClickListener = () => {
        if (!this.selfClick && !this.overlayClick && !this.props.isKeepShow) {
          this.hide();
        }

        this.clearClickState();
      };

      document.addEventListener("click", this.documentClickListener);
    }
  }

  unbindDocumentClickListener() {
    if (this.documentClickListener) {
      document.removeEventListener("click", this.documentClickListener);
      this.documentClickListener = null;
    }
  }

  clearClickState() {
    this.selfClick = false;
    this.editableInputClick = false;
    this.overlayClick = false;
  }

  updateEditableLabel(option) {
    if (this.editableInput) {
      this.editableInput.value = option
        ? this.getOptionLabel(option)
        : this.props.value || "";
    }
  }

  filter(option) {
    let filterValue = this.state.filter.trim().toLowerCase();
    let optionLabel = this.getOptionLabel(option); // || '';

    return optionLabel.toLowerCase().indexOf(filterValue.toLowerCase()) > -1;
  }

  hasFilter() {
    return this.state.filter && this.state.filter.trim().length > 0;
  }

  renderHiddenSelect() {
    if (this.props.autoWidth) {
      let options =
        Array.isArray(this.props.options) &&
        this.props.options.map((option, i) => {
          return (
            <option key={i} value={option.value}>
              {this.getOptionLabel(option)}
            </option>
          );
        });

      return (
        <div className="ui-helper-hidden-accessible">
          <select
            ref={(el) => {
              this.nativeSelect = el;
            }}
            required={this.props.required}
            tabIndex="-1"
            aria-hidden="true"
          >
            {options}
          </select>
        </div>
      );
    } else {
      return null;
    }
  }

  renderKeyboardHelper() {
    return (
      <div className="ui-helper-hidden-accessible">
        <input
          ref={(el) => {
            this.focusInput = el;
          }}
          id={this.props.inputId}
          type="text"
          role="listbox"
          onFocus={this.onInputFocus}
          onBlur={this.onInputBlur}
          onKeyDown={this.onInputKeyDown}
          disabled={this.props.disabled}
          tabIndex={this.props.tabIndex}
          autoFocus={this.props.autoFocus}
        />
      </div>
    );
  }

  renderLabel(label, selectedOption) {
    if (this.props.editable) {
      let value = label || this.props.value || "";

      return (
        <input
          ref={(el) => {
            this.editableInput = el;
          }}
          type="text"
          defaultValue={value}
          className="ui-dropdown-label ui-inputtext ui-corner-all"
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          onClick={this.onEditableInputClick}
          onInput={this.onEditableInputChange}
          onFocus={this.onEditableInputFocus}
          onBlur={this.onInputBlur}
        />
      );
    } else {
      let style = {};
      if (
        this.props.className &&
        this.props.className.indexOf("bg-color-dark") > -1
      ) {
        style = { color: "white" };
      }

      let className = classNames(
        "ui-dropdown-label ui-inputtext ui-corner-all",
        this.props.className,
        {
          "ui-placeholder": label === null && this.props.placeholder,
          "ui-dropdown-label-empty": label === null && !this.props.placeholder,
        }
      );
      if (this.props.labelTemplate && selectedOption) {
        return (
          <label className={className} style={style}>
            {this.props.labelTemplate(selectedOption)}
          </label>
        );
      }
      return (
        <label className={className} style={style}>
          {label || this.props.placeholder || "empty"}
        </label>
      );
    }
  }

  renderClearIcon() {
    if (this.props.value && this.props.showClear && !this.props.disabled) {
      return (
        <i
          className="ui-dropdown-clear-icon fa fa-close"
          onClick={this.clear}
        />
      );
    } else {
      return null;
    }
  }

  renderDropdownIcon() {
    let style = {};
    if (
      this.props.className &&
      this.props.className.indexOf("bg-color-dark") > -1
    ) {
      style = { color: "white" };
    }
    return (
      <div className="ui-dropdown-trigger ui-state-default ui-corner-right">
        <span className="fa fa-fw fa-caret-down ui-clickable" style={style} />
      </div>
    );
  }

  renderGroupOptionNotFound = () => {
    // setTimeout(() => {
    return (
      <span
        style={{
          paddingLeft: 10,
          opacity: 0.8,
          fontSize: 14,
          marginBottom: 8,
          display: "inline-block",
        }}
      >
        No results found.
      </span>
    );
    // }, 500);
  };

  renderItems(selectedOption) {
    let items = this.props.options;

    if (items && this.hasFilter()) {
      items =
        items &&
        items.filter((option) => {
          return this.filter(option);
        });
    }

    if (items.length > 1 || (items.length === 1 && !items[0].except)) {
      //---custom group---//
      if (this.props.groupLabels) {
        return this.props.groupLabels.map((groupItem) => {
          const groupHeader = (
            <div
              style={{
                fontWeight: 500,
                padding: 2,
                fontSize: 11,
                color: "#999",
                textTransform: "uppercase",
              }}
            >
              {groupItem.label}
            </div>
          );
          let isEmpty = true;
          return (
            <div className="group-item" style={{ padding: "0 10px" }}>
              {groupHeader}
              {items.map((option, index) => {
                if (option.extensionValue) {
                  if (
                    groupItem.condition.indexOf(
                      option.extensionValue[groupItem.field]
                    ) > -1
                  ) {
                    isEmpty = false;
                    let optionLabel = this.getOptionLabel(option);
                    return (
                      <DropdownItem
                        key={index}
                        label={optionLabel}
                        option={option}
                        template={this.props.itemTemplate}
                        selected={selectedOption === option}
                        onClick={this.onOptionClick}
                      />
                    );
                  }
                }

                return null;
              })}
              {isEmpty && this.renderGroupOptionNotFound()}
            </div>
          );
        });
      }
      //---end---//
      else {
        return items.map((option, index) => {
          if (!option.except) {
            let optionLabel = this.getOptionLabel(option);
            return (
              <DropdownItem
                key={index}
                label={optionLabel}
                option={option}
                template={this.props.itemTemplate}
                selected={selectedOption === option}
                onClick={this.onOptionClick}
              />
            );
          }
          return null;
        });
      }
    } else {
      return (
        <span
          style={{
            paddingLeft: 10,
            opacity: 0.8,
            fontSize: 14,
            marginBottom: 8,
            display: "inline-block",
          }}
        >
          No results found.
        </span>
      );
    }
  }

  renderFilter() {
    if (this.props.filter) {
      return (
        <div className="ui-dropdown-filter-container">
          <input
            ref={(el) => {
              this.filterInput = el;
            }}
            type="text"
            autoComplete="off"
            className="ui-dropdown-filter ui-inputtext ui-widget ui-state-default ui-corner-all"
            placeholder={this.props.filterPlaceholder}
            onKeyDown={this.onFilterInputKeyDown}
            onChange={this.onFilterInputChange}
          />
          <span className="fa fa-search" />
        </div>
      );
    } else {
      return null;
    }
  }

  getOptionLabel(option) {
    return this.props.optionLabel
      ? ObjectUtils.resolveFieldData(option, this.props.optionLabel)
      : option.label;
  }

  renderLoader() {
    const { loading } = this.props;
    if (!loading) {
      return null;
    }

    return (
      <i
        ref={(el) => {
          this.loader = el;
        }}
        className="ui-autocomplete-loader fa fa-circle-o-notch fa-spin fa-fw"
      />
    );
  }

  validate(val) {
    const value = val || this.props.value;
    const result = value && value.toString().trim() !== "";
    this.setState({ error: !result, errorMessage: this.props.errorMessage });
    return result;
  }

  resetValidate() {
    this.setState({ error: false, errorMessage: "" });
  }

  render() {
    let className = classNames(
      "ui-dropdown ui-widget ui-state-default ui-corner-all ui-helper-clearfix",
      this.props.className,
      {
        "ui-state-disabled": this.props.disabled,
        inputError: this.state.error && !this.state.disabled,
        "ui-dropdown-clearable": this.props.showClear && !this.props.disabled,
      }
    );

    let selectedOption = this.findOption(this.props.value);
    let label = selectedOption ? this.getOptionLabel(selectedOption) : null;

    let hiddenSelect = this.renderHiddenSelect();
    let keyboardHelper = this.renderKeyboardHelper();
    let labelElement = this.renderLabel(label, selectedOption);
    let dropdownIcon = this.renderDropdownIcon();
    let items = this.renderItems(selectedOption);
    let filterElement = this.renderFilter();
    let clearIcon = this.renderClearIcon();

    let loader = this.renderLoader();

    return (
      <div className="box-filestring-dropdown" style={this.props.style}>
        <div
          id={this.props.id}
          ref={(el) => {
            this.container = el;
          }}
          className={className}
          onClick={this.onClick}
          onMouseDown={this.props.onMouseDown}
          onContextMenu={this.props.onContextMenu}
        >
          {hiddenSelect}
          {keyboardHelper}
          {labelElement}
          {dropdownIcon}
          {loader}
          <DropdownPanel
            ref={(el) => {
              this.panel = el;
            }}
            appendTo={this.props.appendTo}
            panelStyle={this.props.panelStyle}
            panelClassName={this.props.panelClassName}
            scrollHeight={this.props.scrollHeight}
            onClick={this.panelClick}
            filter={filterElement}
            isCustom={this.props.onHoverLabel}
          >
            {items}
          </DropdownPanel>
        </div>
        {clearIcon}
        <span className="error">{this.state.errorMessage}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js